import Home from './four-dots.svg';
import Search from './search.svg';
import Avatar from './avatar.svg';
import email from './email.svg';
import lock from './lock.svg';
import user from './user.svg';
import logoDark from './logo-dark.svg';
import address from './address.svg';
import edit from './edit.svg';
import close from './close.svg';
import phone from './phone.svg';

export default {
  Home,
  Search,
  Avatar,
  email,
  lock,
  user,
  logoDark,
  address,
  edit,
  close,
  phone
};
